<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6t4EYB/tc-custom/9781780104782.jpg?1705750615231" alt="This image is the cover for the book Moon Cutters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moon Cutters
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>A Marriage of Convenience</i> spins a Victorian tale “full of dark secrets and deceit . . . An entertaining novel” (Historical Novel Society).</b><br/>  <br/> 1840. Miranda Jarvis would do anything to protect her sister—so when Lucy comes down with a fever, she thinks nothing of stealing a loaf of bread from a local landowner. After all, things can’t get much worse: after their father died, they were turned out of their home, and their mother lost her life on the road giving birth to a stillborn infant. Robbed by strangers, the pair of them have nothing, and no one to help them.<br/>  <br/> Miranda doesn’t count on being nearly brained by the cook’s rolling pin . . . but nor does she count on the house’s owner himself. The seemingly respectable businessman Sir James, known for his philanthropy, takes a keen interest in Miranda and her sister, and they are soon established in his household. But Sir James has quarreled with his nephew, the rakish but reluctant smuggler Fletcher Taunt, and—little does Miranda know—the hostility between the two men, one of whom she comes to love, will change her life forever . . .<br/>  <br/> “A fascinating historical love story full of mystery, struggle, and hope, Woods’ latest is a novel sure to enthrall.” —<i>Booklist</i><br/>  <br/> “A smugglers adventure where two young girls fall prey to the seedier side of human nature more than once, but eventually find the kindness and love they deserve.” —The Zest Quest
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Woods
      </h2>
      
      <p class="authorDescription body article">Janet is an Australian, who was born and raised in Dorset, UK. Happily married since her late teens, she and her husband migrated to Australia with the first two of her family of five, after her husband finished his term in the Royal Navy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79d03112